// Full UI translations for Vespera AI — 5 languages.
export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

const en = {
  brand: "Vespera",
  tagline: "Own your shifts. Protect your rhythm.",
  // auth
  signIn: "Sign in",
  signUp: "Create account",
  name: "Full name",
  email: "Email",
  password: "Password",
  loginCta: "Sign in",
  registerCta: "Create account",
  noAccount: "New here?",
  haveAccount: "Already have an account?",
  authSubLogin: "Welcome back — your schedule is waiting.",
  authSubRegister: "Set up in under a minute.",
  processing: "Please wait…",
  // nav
  navToday: "Today",
  navCalendar: "Calendar",
  navEarnings: "Earnings",
  navSettings: "Settings",
  // shifts
  morning: "Morning",
  afternoon: "Afternoon",
  night: "Night",
  off: "Off",
  // onboarding
  obTitle: "Quick setup",
  obStep: "Step",
  obPatternTitle: "Pick your rotation",
  obPatternSub: "Choose the cycle that matches your rota.",
  obAnchorTitle: "When does the cycle start?",
  obAnchorSub: "The first day of the pattern above.",
  obPayTitle: "Your pay",
  obPaySub: "Used to estimate earnings & bonuses.",
  currency: "Currency",
  hourlyRate: "Hourly rate",
  nightDiff: "Night differential (%)",
  next: "Next",
  back: "Back",
  finish: "Finish setup",
  // today / coach
  hello: "Hello",
  todaysShift: "Today's shift",
  tomorrow: "Tomorrow",
  coachTitle: "Circadian Coach",
  coachSub: "Your plan for today",
  sleepWindow: "Sleep window",
  mealTiming: "Meal timing",
  caffeineCutoff: "Caffeine cut-off",
  workoutSlot: "Workout slot",
  regenerate: "Regenerate",
  coachLoading: "Crafting your plan…",
  // calendar
  calTitle: "Shift calendar",
  editDay: "Edit day",
  setShift: "Set shift for",
  clearOverride: "Reset to pattern",
  // earnings
  earnTitle: "Earnings",
  totalPay: "Estimated total",
  totalHours: "Total hours",
  regularPay: "Base pay",
  overtimePay: "Overtime",
  nightBonus: "Night bonus",
  overtimeHours: "OT hours",
  nightHours: "Night hours",
  breakdown: "Breakdown",
  shiftMix: "Shift mix",
  // settings
  setTitle: "Settings",
  language: "Language",
  overtimeThreshold: "Weekly overtime threshold (h)",
  overtimeMultiplier: "Overtime multiplier",
  rotation: "Rotation pattern",
  save: "Save changes",
  saved: "Settings saved",
  logout: "Log out",
  account: "Account",
  days: "days",
  thisWeek: "This week",
  shiftTimes: "Shift times",
  start: "Start",
  end: "End",
  reminders: "Daily reminders",
  remindersDesc: "Gentle nudges for sleep & caffeine cut-off",
  enableReminders: "Enable reminders",
  remindersBlocked: "Notifications are blocked in your browser",
  remindersOn: "Reminders on",
  exportData: "Export",
  exportCsv: "CSV",
  exportPdf: "PDF",
  exported: "Export ready",
  reminderSleepTitle: "Wind-down time 🌙",
  reminderSleepBody: "Your optimal sleep window starts soon.",
  reminderCaffeineTitle: "Caffeine cut-off ☕",
  reminderCaffeineBody: "Last call for caffeine to protect your sleep.",
  pro: "Pro",
  unlock: "Unlock Pro",
  paywallTitle: "Unlock Vespera Pro",
  paywallSubtitle: "Get your AI coach, insights and more.",
  proFeatures: "AI Circadian Coach · Week View · Pay Export · Daily Reminders",
  monthly: "Monthly",
  yearly: "Yearly",
  perMonth: "/mo",
  perYear: "/yr",
  bestValue: "Best value",
  freeTrialNote: "7-day free trial, cancel anytime",
  startTrial: "Start free trial",
  redirecting: "Redirecting to secure checkout…",
  maybeLater: "Maybe later",
  proActive: "Pro active",
  trialing: "Free trial",
  renewsOn: "Renews on",
  endsOn: "Access until",
  cancelPlan: "Cancel subscription",
  resumePlan: "Resume subscription",
  manageSub: "Subscription",
  verifying: "Confirming your payment…",
  paymentSuccess: "Welcome to Pro! 🎉",
  paymentSuccessSub: "Your subscription is active. Enjoy everything Vespera offers.",
  paymentCanceled: "Checkout canceled",
  paymentCanceledSub: "No charge was made. You can upgrade anytime.",
  goToApp: "Go to app",
  savePct: "Save 17%",
  daysLeftTrial: "days left in your free trial",
  lastTrialDay: "Last day of your free trial",
  switchYearlyTitle: "Save 17% with annual",
  switchYearlyDesc: "Switch to yearly billing — pay less, same Pro.",
  switchYearlyCta: "Switch to yearly",
  switched: "Switched to annual billing",
  teamPlan: "Team plan",
  teamPlanDesc: "One payment covers your whole crew — up to 10 people.",
  getTeam: "Get Team plan",
  inviteCode: "Invite code",
  copied: "Copied",
  seatsUsed: "seats used",
  joinTeamTitle: "Join a team",
  enterCode: "Enter invite code",
  joinBtn: "Join",
  joinedTeam: "You joined the team",
  leaveTeam: "Leave team",
  ownerLabel: "Owner",
  memberLabel: "Member",
  invalidCode: "Invalid code",
  remove: "Remove",
};

const it = {
  brand: "Vespera",
  tagline: "Gestisci i turni. Proteggi il tuo ritmo.",
  signIn: "Accedi",
  signUp: "Crea account",
  name: "Nome completo",
  email: "Email",
  password: "Password",
  loginCta: "Accedi",
  registerCta: "Crea account",
  noAccount: "Sei nuovo?",
  haveAccount: "Hai già un account?",
  authSubLogin: "Bentornato — il tuo calendario ti aspetta.",
  authSubRegister: "Configura in meno di un minuto.",
  processing: "Attendere…",
  navToday: "Oggi",
  navCalendar: "Calendario",
  navEarnings: "Guadagni",
  navSettings: "Impostazioni",
  morning: "Mattina",
  afternoon: "Pomeriggio",
  night: "Notte",
  off: "Riposo",
  obTitle: "Configurazione rapida",
  obStep: "Passo",
  obPatternTitle: "Scegli la rotazione",
  obPatternSub: "Scegli il ciclo che corrisponde ai tuoi turni.",
  obAnchorTitle: "Quando inizia il ciclo?",
  obAnchorSub: "Il primo giorno del modello sopra.",
  obPayTitle: "La tua paga",
  obPaySub: "Usata per stimare guadagni e bonus.",
  currency: "Valuta",
  hourlyRate: "Paga oraria",
  nightDiff: "Maggiorazione notturna (%)",
  next: "Avanti",
  back: "Indietro",
  finish: "Completa",
  hello: "Ciao",
  todaysShift: "Turno di oggi",
  tomorrow: "Domani",
  coachTitle: "Coach Circadiano",
  coachSub: "Il tuo piano per oggi",
  sleepWindow: "Finestra di sonno",
  mealTiming: "Orario dei pasti",
  caffeineCutoff: "Stop caffeina",
  workoutSlot: "Allenamento",
  regenerate: "Rigenera",
  coachLoading: "Sto creando il tuo piano…",
  calTitle: "Calendario turni",
  editDay: "Modifica giorno",
  setShift: "Imposta turno per",
  clearOverride: "Ripristina modello",
  earnTitle: "Guadagni",
  totalPay: "Totale stimato",
  totalHours: "Ore totali",
  regularPay: "Paga base",
  overtimePay: "Straordinari",
  nightBonus: "Bonus notturno",
  overtimeHours: "Ore straord.",
  nightHours: "Ore notturne",
  breakdown: "Dettaglio",
  shiftMix: "Mix turni",
  setTitle: "Impostazioni",
  language: "Lingua",
  overtimeThreshold: "Soglia straordinari settimanale (h)",
  overtimeMultiplier: "Moltiplicatore straordinari",
  rotation: "Modello di rotazione",
  save: "Salva modifiche",
  saved: "Impostazioni salvate",
  logout: "Esci",
  account: "Account",
  days: "giorni",
  thisWeek: "Questa settimana",
  shiftTimes: "Orari dei turni",
  start: "Inizio",
  end: "Fine",
  reminders: "Promemoria giornalieri",
  remindersDesc: "Avvisi gentili per sonno e stop caffeina",
  enableReminders: "Attiva promemoria",
  remindersBlocked: "Le notifiche sono bloccate nel browser",
  remindersOn: "Promemoria attivi",
  exportData: "Esporta",
  exportCsv: "CSV",
  exportPdf: "PDF",
  exported: "Esportazione pronta",
  reminderSleepTitle: "Ora di rilassarsi 🌙",
  reminderSleepBody: "La tua finestra di sonno ottimale inizia a breve.",
  reminderCaffeineTitle: "Stop caffeina ☕",
  reminderCaffeineBody: "Ultima occasione per la caffeina per proteggere il sonno.",
  pro: "Pro",
  unlock: "Sblocca Pro",
  paywallTitle: "Sblocca Vespera Pro",
  paywallSubtitle: "Ottieni il tuo coach AI, gli approfondimenti e altro.",
  proFeatures: "Coach Circadiano AI · Vista settimana · Esporta paga · Promemoria",
  monthly: "Mensile",
  yearly: "Annuale",
  perMonth: "/mese",
  perYear: "/anno",
  bestValue: "Miglior prezzo",
  freeTrialNote: "7 giorni di prova gratuita, disdici quando vuoi",
  startTrial: "Inizia la prova gratuita",
  redirecting: "Reindirizzamento al pagamento sicuro…",
  maybeLater: "Più tardi",
  proActive: "Pro attivo",
  trialing: "Prova gratuita",
  renewsOn: "Si rinnova il",
  endsOn: "Accesso fino al",
  cancelPlan: "Disdici abbonamento",
  resumePlan: "Riattiva abbonamento",
  manageSub: "Abbonamento",
  verifying: "Conferma del pagamento…",
  paymentSuccess: "Benvenuto in Pro! 🎉",
  paymentSuccessSub: "Il tuo abbonamento è attivo. Goditi tutto ciò che Vespera offre.",
  paymentCanceled: "Pagamento annullato",
  paymentCanceledSub: "Nessun addebito effettuato. Puoi passare a Pro quando vuoi.",
  goToApp: "Vai all'app",
  savePct: "Risparmia 17%",
  daysLeftTrial: "giorni alla fine della prova gratuita",
  lastTrialDay: "Ultimo giorno della prova gratuita",
  switchYearlyTitle: "Risparmia 17% con l'annuale",
  switchYearlyDesc: "Passa alla fatturazione annuale — paghi meno, stesso Pro.",
  switchYearlyCta: "Passa all'annuale",
  switched: "Passato alla fatturazione annuale",
  teamPlan: "Piano Team",
  teamPlanDesc: "Un unico pagamento per tutta la squadra — fino a 10 persone.",
  getTeam: "Attiva il piano Team",
  inviteCode: "Codice invito",
  copied: "Copiato",
  seatsUsed: "posti usati",
  joinTeamTitle: "Unisciti a un team",
  enterCode: "Inserisci il codice invito",
  joinBtn: "Unisciti",
  joinedTeam: "Ti sei unito al team",
  leaveTeam: "Lascia il team",
  ownerLabel: "Titolare",
  memberLabel: "Membro",
  invalidCode: "Codice non valido",
  remove: "Rimuovi",
};

const es = {
  brand: "Vespera",
  tagline: "Domina tus turnos. Protege tu ritmo.",
  signIn: "Iniciar sesión",
  signUp: "Crear cuenta",
  name: "Nombre completo",
  email: "Correo",
  password: "Contraseña",
  loginCta: "Iniciar sesión",
  registerCta: "Crear cuenta",
  noAccount: "¿Eres nuevo?",
  haveAccount: "¿Ya tienes cuenta?",
  authSubLogin: "Bienvenido de nuevo — tu horario te espera.",
  authSubRegister: "Configura en menos de un minuto.",
  processing: "Espera…",
  navToday: "Hoy",
  navCalendar: "Calendario",
  navEarnings: "Ingresos",
  navSettings: "Ajustes",
  morning: "Mañana",
  afternoon: "Tarde",
  night: "Noche",
  off: "Libre",
  obTitle: "Configuración rápida",
  obStep: "Paso",
  obPatternTitle: "Elige tu rotación",
  obPatternSub: "Elige el ciclo que coincide con tu turno.",
  obAnchorTitle: "¿Cuándo empieza el ciclo?",
  obAnchorSub: "El primer día del patrón anterior.",
  obPayTitle: "Tu salario",
  obPaySub: "Se usa para estimar ingresos y bonos.",
  currency: "Moneda",
  hourlyRate: "Tarifa por hora",
  nightDiff: "Plus nocturno (%)",
  next: "Siguiente",
  back: "Atrás",
  finish: "Finalizar",
  hello: "Hola",
  todaysShift: "Turno de hoy",
  tomorrow: "Mañana",
  coachTitle: "Coach Circadiano",
  coachSub: "Tu plan para hoy",
  sleepWindow: "Ventana de sueño",
  mealTiming: "Horario de comidas",
  caffeineCutoff: "Corte de cafeína",
  workoutSlot: "Entrenamiento",
  regenerate: "Regenerar",
  coachLoading: "Creando tu plan…",
  calTitle: "Calendario de turnos",
  editDay: "Editar día",
  setShift: "Fijar turno para",
  clearOverride: "Restablecer patrón",
  earnTitle: "Ingresos",
  totalPay: "Total estimado",
  totalHours: "Horas totales",
  regularPay: "Salario base",
  overtimePay: "Horas extra",
  nightBonus: "Bono nocturno",
  overtimeHours: "Horas extra",
  nightHours: "Horas nocturnas",
  breakdown: "Desglose",
  shiftMix: "Mezcla de turnos",
  setTitle: "Ajustes",
  language: "Idioma",
  overtimeThreshold: "Umbral semanal de horas extra (h)",
  overtimeMultiplier: "Multiplicador horas extra",
  rotation: "Patrón de rotación",
  save: "Guardar cambios",
  saved: "Ajustes guardados",
  logout: "Cerrar sesión",
  account: "Cuenta",
  days: "días",
  thisWeek: "Esta semana",
  shiftTimes: "Horarios de turnos",
  start: "Inicio",
  end: "Fin",
  reminders: "Recordatorios diarios",
  remindersDesc: "Avisos suaves para sueño y corte de cafeína",
  enableReminders: "Activar recordatorios",
  remindersBlocked: "Las notificaciones están bloqueadas en el navegador",
  remindersOn: "Recordatorios activos",
  exportData: "Exportar",
  exportCsv: "CSV",
  exportPdf: "PDF",
  exported: "Exportación lista",
  reminderSleepTitle: "Hora de relajarse 🌙",
  reminderSleepBody: "Tu ventana de sueño óptima empieza pronto.",
  reminderCaffeineTitle: "Corte de cafeína ☕",
  reminderCaffeineBody: "Última oportunidad para la cafeína y proteger tu sueño.",
  pro: "Pro",
  unlock: "Desbloquear Pro",
  paywallTitle: "Desbloquea Vespera Pro",
  paywallSubtitle: "Obtén tu coach IA, análisis y más.",
  proFeatures: "Coach Circadiano IA · Vista semanal · Exportar pago · Recordatorios",
  monthly: "Mensual",
  yearly: "Anual",
  perMonth: "/mes",
  perYear: "/año",
  bestValue: "Mejor precio",
  freeTrialNote: "7 días de prueba gratis, cancela cuando quieras",
  startTrial: "Iniciar prueba gratis",
  redirecting: "Redirigiendo al pago seguro…",
  maybeLater: "Más tarde",
  proActive: "Pro activo",
  trialing: "Prueba gratis",
  renewsOn: "Se renueva el",
  endsOn: "Acceso hasta",
  cancelPlan: "Cancelar suscripción",
  resumePlan: "Reanudar suscripción",
  manageSub: "Suscripción",
  verifying: "Confirmando tu pago…",
  paymentSuccess: "¡Bienvenido a Pro! 🎉",
  paymentSuccessSub: "Tu suscripción está activa. Disfruta todo lo que Vespera ofrece.",
  paymentCanceled: "Pago cancelado",
  paymentCanceledSub: "No se realizó ningún cargo. Puedes mejorar cuando quieras.",
  goToApp: "Ir a la app",
  savePct: "Ahorra 17%",
  daysLeftTrial: "días restantes de tu prueba gratis",
  lastTrialDay: "Último día de tu prueba gratis",
  switchYearlyTitle: "Ahorra 17% con el anual",
  switchYearlyDesc: "Cambia a facturación anual — paga menos, mismo Pro.",
  switchYearlyCta: "Cambiar a anual",
  switched: "Cambiado a facturación anual",
  teamPlan: "Plan Equipo",
  teamPlanDesc: "Un pago cubre a todo tu equipo — hasta 10 personas.",
  getTeam: "Obtener plan Equipo",
  inviteCode: "Código de invitación",
  copied: "Copiado",
  seatsUsed: "plazas usadas",
  joinTeamTitle: "Unirse a un equipo",
  enterCode: "Introduce el código",
  joinBtn: "Unirse",
  joinedTeam: "Te uniste al equipo",
  leaveTeam: "Salir del equipo",
  ownerLabel: "Propietario",
  memberLabel: "Miembro",
  invalidCode: "Código no válido",
  remove: "Quitar",
};

const fr = {
  brand: "Vespera",
  tagline: "Maîtrisez vos gardes. Protégez votre rythme.",
  signIn: "Se connecter",
  signUp: "Créer un compte",
  name: "Nom complet",
  email: "E-mail",
  password: "Mot de passe",
  loginCta: "Se connecter",
  registerCta: "Créer un compte",
  noAccount: "Nouveau ici ?",
  haveAccount: "Vous avez déjà un compte ?",
  authSubLogin: "Bon retour — votre planning vous attend.",
  authSubRegister: "Configuration en moins d'une minute.",
  processing: "Patientez…",
  navToday: "Aujourd'hui",
  navCalendar: "Calendrier",
  navEarnings: "Revenus",
  navSettings: "Réglages",
  morning: "Matin",
  afternoon: "Après-midi",
  night: "Nuit",
  off: "Repos",
  obTitle: "Configuration rapide",
  obStep: "Étape",
  obPatternTitle: "Choisissez votre rotation",
  obPatternSub: "Choisissez le cycle correspondant à votre planning.",
  obAnchorTitle: "Quand commence le cycle ?",
  obAnchorSub: "Le premier jour du modèle ci-dessus.",
  obPayTitle: "Votre salaire",
  obPaySub: "Utilisé pour estimer revenus et primes.",
  currency: "Devise",
  hourlyRate: "Taux horaire",
  nightDiff: "Majoration de nuit (%)",
  next: "Suivant",
  back: "Retour",
  finish: "Terminer",
  hello: "Bonjour",
  todaysShift: "Garde du jour",
  tomorrow: "Demain",
  coachTitle: "Coach Circadien",
  coachSub: "Votre plan du jour",
  sleepWindow: "Fenêtre de sommeil",
  mealTiming: "Horaire des repas",
  caffeineCutoff: "Arrêt caféine",
  workoutSlot: "Créneau sport",
  regenerate: "Régénérer",
  coachLoading: "Création de votre plan…",
  calTitle: "Calendrier des gardes",
  editDay: "Modifier le jour",
  setShift: "Définir la garde pour",
  clearOverride: "Rétablir le modèle",
  earnTitle: "Revenus",
  totalPay: "Total estimé",
  totalHours: "Heures totales",
  regularPay: "Salaire de base",
  overtimePay: "Heures sup.",
  nightBonus: "Prime de nuit",
  overtimeHours: "Heures sup.",
  nightHours: "Heures de nuit",
  breakdown: "Détail",
  shiftMix: "Répartition",
  setTitle: "Réglages",
  language: "Langue",
  overtimeThreshold: "Seuil hebdo heures sup. (h)",
  overtimeMultiplier: "Multiplicateur heures sup.",
  rotation: "Modèle de rotation",
  save: "Enregistrer",
  saved: "Réglages enregistrés",
  logout: "Déconnexion",
  account: "Compte",
  days: "jours",
  thisWeek: "Cette semaine",
  shiftTimes: "Horaires des gardes",
  start: "Début",
  end: "Fin",
  reminders: "Rappels quotidiens",
  remindersDesc: "Rappels doux pour sommeil et arrêt caféine",
  enableReminders: "Activer les rappels",
  remindersBlocked: "Les notifications sont bloquées dans le navigateur",
  remindersOn: "Rappels activés",
  exportData: "Exporter",
  exportCsv: "CSV",
  exportPdf: "PDF",
  exported: "Export prêt",
  reminderSleepTitle: "Heure de décompresser 🌙",
  reminderSleepBody: "Votre fenêtre de sommeil optimale commence bientôt.",
  reminderCaffeineTitle: "Arrêt caféine ☕",
  reminderCaffeineBody: "Dernier appel caféine pour protéger votre sommeil.",
  pro: "Pro",
  unlock: "Débloquer Pro",
  paywallTitle: "Débloquez Vespera Pro",
  paywallSubtitle: "Obtenez votre coach IA, des analyses et plus.",
  proFeatures: "Coach circadien IA · Vue semaine · Export paie · Rappels",
  monthly: "Mensuel",
  yearly: "Annuel",
  perMonth: "/mois",
  perYear: "/an",
  bestValue: "Meilleur prix",
  freeTrialNote: "7 jours d'essai gratuit, annulez à tout moment",
  startTrial: "Commencer l'essai gratuit",
  redirecting: "Redirection vers le paiement sécurisé…",
  maybeLater: "Plus tard",
  proActive: "Pro actif",
  trialing: "Essai gratuit",
  renewsOn: "Renouvellement le",
  endsOn: "Accès jusqu'au",
  cancelPlan: "Annuler l'abonnement",
  resumePlan: "Reprendre l'abonnement",
  manageSub: "Abonnement",
  verifying: "Confirmation de votre paiement…",
  paymentSuccess: "Bienvenue dans Pro ! 🎉",
  paymentSuccessSub: "Votre abonnement est actif. Profitez de tout ce que Vespera offre.",
  paymentCanceled: "Paiement annulé",
  paymentCanceledSub: "Aucun débit effectué. Vous pouvez passer à Pro à tout moment.",
  goToApp: "Aller à l'app",
  savePct: "Économisez 17%",
  daysLeftTrial: "jours restants dans votre essai gratuit",
  lastTrialDay: "Dernier jour de votre essai gratuit",
  switchYearlyTitle: "Économisez 17% avec l'annuel",
  switchYearlyDesc: "Passez à la facturation annuelle — payez moins, même Pro.",
  switchYearlyCta: "Passer à l'annuel",
  switched: "Passé à la facturation annuelle",
  teamPlan: "Forfait Équipe",
  teamPlanDesc: "Un seul paiement pour toute l'équipe — jusqu'à 10 personnes.",
  getTeam: "Obtenir le forfait Équipe",
  inviteCode: "Code d'invitation",
  copied: "Copié",
  seatsUsed: "places utilisées",
  joinTeamTitle: "Rejoindre une équipe",
  enterCode: "Entrez le code d'invitation",
  joinBtn: "Rejoindre",
  joinedTeam: "Vous avez rejoint l'équipe",
  leaveTeam: "Quitter l'équipe",
  ownerLabel: "Propriétaire",
  memberLabel: "Membre",
  invalidCode: "Code invalide",
  remove: "Retirer",
};

const de = {
  brand: "Vespera",
  tagline: "Meistere deine Schichten. Schütze deinen Rhythmus.",
  signIn: "Anmelden",
  signUp: "Konto erstellen",
  name: "Vollständiger Name",
  email: "E-Mail",
  password: "Passwort",
  loginCta: "Anmelden",
  registerCta: "Konto erstellen",
  noAccount: "Neu hier?",
  haveAccount: "Schon ein Konto?",
  authSubLogin: "Willkommen zurück — dein Plan wartet.",
  authSubRegister: "In unter einer Minute eingerichtet.",
  processing: "Bitte warten…",
  navToday: "Heute",
  navCalendar: "Kalender",
  navEarnings: "Verdienst",
  navSettings: "Einstellungen",
  morning: "Früh",
  afternoon: "Spät",
  night: "Nacht",
  off: "Frei",
  obTitle: "Schnell-Setup",
  obStep: "Schritt",
  obPatternTitle: "Wähle deine Rotation",
  obPatternSub: "Wähle den Zyklus, der zu deinem Dienstplan passt.",
  obAnchorTitle: "Wann beginnt der Zyklus?",
  obAnchorSub: "Der erste Tag des Musters oben.",
  obPayTitle: "Dein Lohn",
  obPaySub: "Zur Schätzung von Verdienst und Zuschlägen.",
  currency: "Währung",
  hourlyRate: "Stundenlohn",
  nightDiff: "Nachtzuschlag (%)",
  next: "Weiter",
  back: "Zurück",
  finish: "Fertig",
  hello: "Hallo",
  todaysShift: "Heutige Schicht",
  tomorrow: "Morgen",
  coachTitle: "Zirkadian-Coach",
  coachSub: "Dein Plan für heute",
  sleepWindow: "Schlaffenster",
  mealTiming: "Mahlzeiten",
  caffeineCutoff: "Koffein-Stopp",
  workoutSlot: "Training",
  regenerate: "Neu erzeugen",
  coachLoading: "Dein Plan wird erstellt…",
  calTitle: "Schichtkalender",
  editDay: "Tag bearbeiten",
  setShift: "Schicht setzen für",
  clearOverride: "Auf Muster zurücksetzen",
  earnTitle: "Verdienst",
  totalPay: "Geschätzt gesamt",
  totalHours: "Gesamtstunden",
  regularPay: "Grundlohn",
  overtimePay: "Überstunden",
  nightBonus: "Nachtzuschlag",
  overtimeHours: "Überstd.",
  nightHours: "Nachtstunden",
  breakdown: "Aufschlüsselung",
  shiftMix: "Schichtmix",
  setTitle: "Einstellungen",
  language: "Sprache",
  overtimeThreshold: "Wöchentliche Überstundengrenze (h)",
  overtimeMultiplier: "Überstunden-Faktor",
  rotation: "Rotationsmuster",
  save: "Speichern",
  saved: "Einstellungen gespeichert",
  logout: "Abmelden",
  account: "Konto",
  days: "Tage",
  thisWeek: "Diese Woche",
  shiftTimes: "Schichtzeiten",
  start: "Beginn",
  end: "Ende",
  reminders: "Tägliche Erinnerungen",
  remindersDesc: "Sanfte Hinweise für Schlaf & Koffein-Stopp",
  enableReminders: "Erinnerungen aktivieren",
  remindersBlocked: "Benachrichtigungen sind im Browser blockiert",
  remindersOn: "Erinnerungen aktiv",
  exportData: "Export",
  exportCsv: "CSV",
  exportPdf: "PDF",
  exported: "Export bereit",
  reminderSleepTitle: "Zeit zum Runterkommen 🌙",
  reminderSleepBody: "Dein optimales Schlaffenster beginnt bald.",
  reminderCaffeineTitle: "Koffein-Stopp ☕",
  reminderCaffeineBody: "Letzte Chance auf Koffein, um den Schlaf zu schützen.",
  pro: "Pro",
  unlock: "Pro freischalten",
  paywallTitle: "Vespera Pro freischalten",
  paywallSubtitle: "Hol dir deinen KI-Coach, Insights und mehr.",
  proFeatures: "KI-Zirkadian-Coach · Wochenansicht · Lohn-Export · Erinnerungen",
  monthly: "Monatlich",
  yearly: "Jährlich",
  perMonth: "/Mon.",
  perYear: "/Jahr",
  bestValue: "Bester Preis",
  freeTrialNote: "7 Tage kostenlos testen, jederzeit kündbar",
  startTrial: "Kostenlos testen",
  redirecting: "Weiterleitung zur sicheren Zahlung…",
  maybeLater: "Später",
  proActive: "Pro aktiv",
  trialing: "Testphase",
  renewsOn: "Verlängert am",
  endsOn: "Zugang bis",
  cancelPlan: "Abo kündigen",
  resumePlan: "Abo fortsetzen",
  manageSub: "Abo",
  verifying: "Zahlung wird bestätigt…",
  paymentSuccess: "Willkommen bei Pro! 🎉",
  paymentSuccessSub: "Dein Abo ist aktiv. Genieße alles, was Vespera bietet.",
  paymentCanceled: "Zahlung abgebrochen",
  paymentCanceledSub: "Es wurde nichts berechnet. Du kannst jederzeit upgraden.",
  goToApp: "Zur App",
  savePct: "17% sparen",
  daysLeftTrial: "Tage in deiner kostenlosen Testphase",
  lastTrialDay: "Letzter Tag deiner Testphase",
  switchYearlyTitle: "17% sparen mit Jahresabo",
  switchYearlyDesc: "Wechsle zur jährlichen Abrechnung — weniger zahlen, gleiches Pro.",
  switchYearlyCta: "Zu jährlich wechseln",
  switched: "Zur jährlichen Abrechnung gewechselt",
  teamPlan: "Team-Tarif",
  teamPlanDesc: "Eine Zahlung für dein ganzes Team — bis zu 10 Personen.",
  getTeam: "Team-Tarif holen",
  inviteCode: "Einladungscode",
  copied: "Kopiert",
  seatsUsed: "Plätze belegt",
  joinTeamTitle: "Team beitreten",
  enterCode: "Einladungscode eingeben",
  joinBtn: "Beitreten",
  joinedTeam: "Du bist dem Team beigetreten",
  leaveTeam: "Team verlassen",
  ownerLabel: "Inhaber",
  memberLabel: "Mitglied",
  invalidCode: "Ungültiger Code",
  remove: "Entfernen",
};

export const translations = { en, it, es, fr, de };

export const PATTERN_LABELS = {
  en: { classic_rotating: "Classic rotating (2-2-2-2)", mans_off: "M / A / N / Off", five_mornings: "5 mornings + 2 off", continental: "Continental (2-2-2)", nights_block: "Night block (3 on / 2 off)" },
  it: { classic_rotating: "Rotazione classica (2-2-2-2)", mans_off: "M / P / N / Riposo", five_mornings: "5 mattine + 2 riposo", continental: "Continentale (2-2-2)", nights_block: "Blocco notti (3 / 2)" },
  es: { classic_rotating: "Rotación clásica (2-2-2-2)", mans_off: "M / T / N / Libre", five_mornings: "5 mañanas + 2 libres", continental: "Continental (2-2-2)", nights_block: "Bloque noches (3 / 2)" },
  fr: { classic_rotating: "Rotation classique (2-2-2-2)", mans_off: "M / AM / N / Repos", five_mornings: "5 matins + 2 repos", continental: "Continental (2-2-2)", nights_block: "Bloc nuits (3 / 2)" },
  de: { classic_rotating: "Klassische Rotation (2-2-2-2)", mans_off: "F / S / N / Frei", five_mornings: "5 Früh + 2 frei", continental: "Kontinental (2-2-2)", nights_block: "Nachtblock (3 / 2)" },
};

export const CURRENCIES = [
  { code: "EUR", symbol: "€" },
  { code: "USD", symbol: "$" },
  { code: "GBP", symbol: "£" },
  { code: "CHF", symbol: "CHF" },
  { code: "CAD", symbol: "C$" },
  { code: "AUD", symbol: "A$" },
  { code: "JPY", symbol: "¥" },
  { code: "INR", symbol: "₹" },
];

export function currencySymbol(code) {
  const c = CURRENCIES.find((x) => x.code === code);
  return c ? c.symbol : code;
}
